import React from 'react';

import type { SharedValue } from 'react-native-reanimated';
import type { ListRef } from '@banhala/ui-kit';
import type { GoodsDetailContentKeys } from '../types/GoodsDetailContentKeys';
import type { GoodsDetailTab } from '../types/GoodsDetailTab';

export const ScrollContext = React.createContext<{
  scrollY?: SharedValue<number>;
  tabScrollX?: SharedValue<number>;
  listRef?: React.RefObject<ListRef<GoodsDetailContentKeys> | null>;
  scrollToStickyView?: () => void;
  changeContentTab?: (tab: GoodsDetailTab) => void;
  onChangeTab?: (tab: GoodsDetailTab) => void;
}>({});
